module.exports = __webpack_public_path__ + "img/Recurso 7.9497f51c.png";